import {BaseDTO} from '@/app/dto/BaseDTO';

export class LabelDTO extends BaseDTO {

    public name: string = null;

}
